<div class="lobby-layout flex-grow-1 position-relative">

    @if(!this.isConnected()) {
    <div class="position-absolute top-50 start-50 translate-middle text-center">
        <div class="progress" role="progressbar" aria-label="Danger example" aria-valuenow="100" aria-valuemin="0"
            aria-valuemax="100">
            <div class="progress-bar progress-bar-striped progress-bar-animated bg-danger" style="width: 100%"></div>
        </div>
        Connecting...
    </div>
    }

    <!--player-list-->
    <app-player-list class="user-list-panel d-none d-lg-flex flex-column"></app-player-list>
    <!--./player-list-->

    <!--chat-area-->
    <section class="chat-area d-flex flex-column">
        @if(arena()) {

        <header class="chat-header px-3 py-2 d-flex align-items-center">
            @if(canEditLobby()) {
            <i class="bi bi-pencil-fill fs-5 cursor-pointer text-secondary hover-white" style="cursor: pointer;"
                title="Edit Lobby" data-bs-toggle="modal" data-bs-target="#editRoomModal"></i>
            }@else{
            <i class="bi bi-hash fs-4 text-secondary"></i>
            }
            <h4 class="fw-bold mb-0 ms-2 text-truncate">{{ arena().title }}</h4>

            <!--mobile-toggle-buttons-->
            <div class="ms-auto d-flex gap-2">
                @if(arena().parentGuid != null && arena().url != '') {
                <button type="button" class="btn btn-primary" title="Sign Up" data-bs-toggle="modal"
                    data-bs-target="#externalLinkModal" (click)="openLink(arena().url)">Tourney</button>
                }
                <button class="btn btn-dark" type="button" aria-controls="fontSize" title="Increase Font Size"
                    (click)="zoomIn()" [disabled]="zoomLevel() >= 3">
                    <i class="bi bi-zoom-in"></i>
                </button>
                <button class="btn btn-dark" type="button" aria-controls="fontSize" title="Decrease Font Size"
                    (click)="zoomOut()" [disabled]="zoomLevel() <= -3">
                    <i class="bi bi-zoom-out"></i>
                </button>
                <button class="btn btn-dark" type="button" title="Clear Chat" data-bs-toggle="modal"
                    data-bs-target="#clearChatModal">
                    <i class="bi bi-trash-fill"></i>
                </button>
                <button class="btn btn-dark d-lg-none" type="button" data-bs-toggle="offcanvas"
                    data-bs-target="#playerListOffcanvas" aria-controls="playerListOffcanvas" title="Show Players">
                    <i class="bi bi-people-fill"></i>
                </button>
                @if(arena() && arena().parentGuid == null) {
                <button class="btn btn-dark d-lg-none" type="button" data-bs-toggle="offcanvas"
                    data-bs-target="#arenaListOffcanvas" aria-controls="arenaListOffcanvas" title="Show Arenas">
                    <i class="bi bi-view-list"></i>
                </button>
                }
                <button class="btn btn-danger" type="button" title="Leave" (click)="leave()">
                    <i class="bi bi-arrow-bar-right"></i>
                </button>
            </div>
            <!--./mobile-toggle-buttons-->

        </header>

        <!-- Centered Toolbar Row -->
        @if(arena().parentGuid != null){
        <div class="chat-toolbar-wrapper d-flex justify-content-center">
            <div
                class="chat-toolbar d-flex align-items-center justify-content-center rounded-bottom overflow-hidden shadow-lg">

                <button type="button"
                    class="btn btn-ready flex-fill m-0 d-flex align-items-center justify-content-center h-100 border-0"
                    [class.is-ready]="isReady()" (click)="toggleReady()" title="Toggle Ready"
                    style="height: 28px; line-height: 1;">
                    <i class="bi me-1" [class.bi-check-circle-fill]="isReady()" [class.bi-circle]="!isReady()"></i>
                    {{ isReady() ? 'Ready' : 'Ready Up' }}
                </button>

                @if(canEditLobby()) {
                <button type="button"
                    class="btn btn-outline-light border-0 flex-fill m-0 rounded-0 d-flex align-items-center justify-content-center h-100 fw-bold"
                    data-bs-toggle="modal" data-bs-target="#gameSettingsModal" title="Game Settings">
                    <i class="bi bi-gear-fill me-1"></i>
                    <span>Settings</span>
                </button>
                }
                @if(canEditLobby() && games()[0]?.gameType === 2) {
                <button type="button"
                    class="btn btn-warning flex-fill m-0 rounded-0 d-flex align-items-center justify-content-center h-100 text-dark fw-bold"
                    data-bs-toggle="modal" data-bs-target="#serverBrowserModal" title="Browse Servers">
                    <i class="bi bi-search me-1"></i>
                    <span>Browse</span>
                </button>
                }

                @if(canEditLobby()) {
                <button type="button"
                    class="btn btn-danger flex-fill m-0 rounded-0 d-flex align-items-center justify-content-center h-100"
                    (click)="launchGame()" title="Launch Game">
                    <i class="bi bi-rocket-takeoff me-1"></i>
                    <span class="me-1 fw-bold">Launch</span>
                </button>
                }
            </div>
        </div>
        }


        @if(arena().hasVideo || arena().hasVoice) {
        <!--<div class="p-3 border-top border-dark text-center">
            <button class="btn btn-secondary" (click)="produce()">Start</button>
            <video autoplay muted [srcObject]="localStream()" class="bg-black me-3"
                style="width: 256px; height: 256px;"></video>
            @for(stream of remoteStreams() | keyvalue; track stream.key) {
            {{stream.key}}
            <video autoplay muted class="bg-black me-3" style="width: 256px; height: 256px;" #remoteVideo></video>
            }
        </div>-->
        }

        <div class="chat-messages-container flex-grow-1 position-relative overflow-hidden">
            <div class="chat-messages h-100 overflow-y-auto p-3" [style.font-size]="(1 + zoomLevel() * 0.12) + 'rem'"
                #msgEl>
                @for(message of messages(); track $index) {
                <app-message [message]="message" [showModerator]="true"></app-message>
                }

                <div #bottomAnchor></div>
            </div>

            @if(showCelebration()) {
            <div class="celebration-container">
                <div class="confetti"></div>
                <div class="confetti"></div>
                <div class="confetti"></div>
                <div class="confetti"></div>
                <div class="confetti"></div>
                <div class="confetti"></div>
                <div class="confetti"></div>
                <div class="confetti"></div>
                <div class="confetti"></div>
                <div class="confetti"></div>
                <div class="confetti"></div>
                <div class="confetti"></div>
            </div>
            }

            @if(showBirthday()) {
            <div class="birthday-container">
                <div class="cake-wrapper">
                    <div class="candle">
                        <div class="flame"></div>
                    </div>
                    <div class="cake-layer layer-top"></div>
                    <div class="cake-layer layer-middle"></div>
                    <div class="cake-layer layer-bottom"></div>
                </div>
            </div>
            }

            @if(showSnow()) {
            <div class="snow-container">
                <div class="snowflake">❄️</div>
                <div class="snowflake">❅</div>
                <div class="snowflake">❆</div>
                <div class="snowflake">❄️</div>
                <div class="snowflake">❅</div>
                <div class="snowflake">❆</div>
                <div class="snowflake">❄️</div>
                <div class="snowflake">❅</div>
                <div class="snowflake">❆</div>
                <div class="snowflake">❄️</div>
                <div class="snowflake">❅</div>
                <div class="snowflake">❆</div>
            </div>
            }

            @if(showFireworks()) {
            <div class="fireworks-container">
                <div class="firework firework-1">
                    <div class="rocket"></div>
                    <div class="explosion">
                        @for (i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]; track $index) {
                        <div class="spark"></div>
                        }
                    </div>
                </div>
                <div class="firework firework-2">
                    <div class="rocket"></div>
                    <div class="explosion">
                        @for (i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]; track $index) {
                        <div class="spark"></div>
                        }
                    </div>
                </div>
                <div class="firework firework-3">
                    <div class="rocket"></div>
                    <div class="explosion">
                        @for (i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]; track $index) {
                        <div class="spark"></div>
                        }
                    </div>
                </div>
                <div class="firework firework-4">
                    <div class="rocket"></div>
                    <div class="explosion">
                        @for (i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]; track $index) {
                        <div class="spark"></div>
                        }
                    </div>
                </div>
                <div class="firework firework-5">
                    <div class="rocket"></div>
                    <div class="explosion">
                        @for (i of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]; track $index) {
                        <div class="spark"></div>
                        }
                    </div>
                </div>
            </div>
            }
        </div>


        <div class="chat-input-wrapper p-3 position-relative">
            @if(showGiphy()) {
            <div class="giphy-popup position-absolute bottom-100 start-0 m-2 mb-2 p-3 bg-dark border border-secondary rounded shadow-lg"
                style="width: 400px; height: 500px; z-index: 1000;">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h6 class="mb-0 text-white">Search GIPHY</h6>
                    <button type="button" class="btn-close btn-close-white" (click)="showGiphy.set(false)"></button>
                </div>
                <input type="text" class="form-control mb-3 bg-black text-white border-secondary"
                    placeholder="Search GIFs..." #giphySearchBox (input)="giphySearch(giphySearchBox.value)">
                <div class="giphy-results overflow-auto" style="height: calc(100% - 100px);">
                    <div class="row g-2">
                        @for(gif of giphy.searchResults(); track gif.id) {
                        <div class="col-4">
                            <img [src]="gif.images.fixed_height_small.url"
                                class="img-fluid rounded cursor-pointer hover-opacity" [alt]="gif.title"
                                (click)="selectGif(gif)">
                        </div>
                        }
                        @if(giphy.searchResults().length === 0) {
                        <div class="col-12 text-center text-muted mt-5">
                            <i class="bi bi-search fs-1"></i>
                            <p>Search for something cool!</p>
                        </div>
                        }
                    </div>
                </div>
            </div>
            }
            @if(showEmoji()) {
            <app-emoji-picker class="emoji-popup position-absolute bottom-100 end-0 m-2 mb-2"
                (selectEmoji)="insertEmoji($event, messageBox)" (closePicker)="showEmoji.set(false)">
            </app-emoji-picker>
            }
            <div class="input-group">
                <input type="text" class="form-control chat-input p-3 border-0"
                    placeholder="Message in {{ arena().title }}" name="newMessage" [ngModel]="newMessage()"
                    (ngModelChange)="newMessage.set($event)"
                    (keydown.enter)="send(messageBox.value); messageBox.value = ''; newMessage.set('')" #messageBox>
                <button type="button" class="btn btn-dark border-0 px-3 d-flex align-items-center"
                    (click)="$event.stopPropagation(); toggleEmoji()" title="Emoji">
                    <i class="bi bi-emoji-smile fs-5"></i>
                </button>
                <button type="button" class="btn btn-dark border-0 px-3 d-flex align-items-center"
                    (click)="toggleGiphy()" title="GIPHY">
                    <i class="bi bi-file-earmark-image fs-5"></i>
                </button>
            </div>
        </div>
        }@else {
        <div class="col-12 text-center text-muted py-5">
            <h5>Connecting...</h5>
            <p>This should take less than 5 seconds.</p>
        </div>
        }
    </section>
    <!--./chat-area-->

    <!--room-list-->
    @if(arena() && arena().parentGuid == null) {
    <app-room-list [isMobile]="false" class="room-list-panel d-none d-lg-flex flex-column"></app-room-list>
    }
    <!--./room-list-->
</div>

<!--mobile-player-list-->
<div class="offcanvas offcanvas-start text-light d-lg-none" tabindex="-1" id="playerListOffcanvas"
    aria-labelledby="playerListOffcanvasLabel" style="background-color: #222; border-right: 1px solid #333;">
    <div class="offcanvas-header" style="border-bottom: 1px solid #333;">
        <h5 class="offcanvas-title" id="playerListOffcanvasLabel">Players</h5>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body p-3">

        <app-player-list></app-player-list>

    </div>
</div>
<!--./mobile-player-list-->

<!--mobile-room-list-->
<app-room-list [isMobile]="true" class="d-lg-none"></app-room-list>
<!--./mobile-room-list-->

@if(arena() != null) {
<app-create-room-modal [parentGuid]="arena().guid"></app-create-room-modal>
<app-edit-room-modal></app-edit-room-modal>
<app-external-link-modal></app-external-link-modal>
<app-clear-chat-modal></app-clear-chat-modal>
<app-user-profile-modal></app-user-profile-modal>
<app-server-browser-modal [gameTitle]="games()[0]?.title || 'Quake II'"
    (selectServer)="onServerSelected($event)"></app-server-browser-modal>
<app-game-settings-modal #gameSettingsModalRef [gameId]="games()[0]?.gameId || 1" [gameTitle]="games()[0]?.title || 'Rival Forge Spades'"
    [roomGuid]="arena()?.guid || ''" (settingsSaved)="gameSettingsData.set($event)"></app-game-settings-modal>
<app-update-game-modal [game]="uninstalledGame()" (gameUpdated)="onGameInstalled()"></app-update-game-modal>
}